import { render, staticRenderFns } from "./forgotpassword.vue?vue&type=template&id=68c502a6&"
import script from "./forgotpassword.vue?vue&type=script&lang=js&"
export * from "./forgotpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports